import { experimental_useObject as useObject } from "@ai-sdk/react";
import * as React from "react";
import { openRouterConfig } from "@/lib/model";
import type { HNStory } from "@/lib/hn";

export type SummaryProps = {
  hnStory: HNStory;
  isShowing: boolean;
};

export const Summary = ({ hnStory, isShowing }: SummaryProps) => {
  const { object, submit, isLoading } = useObject({
    api: "/api/generate",
    schema: openRouterConfig.schema,
    onError: (error) => {
      console.error(error, { storyId: hnStory.id, event: "summary_generation_failed" });
    },
  });

  const submit2 = React.useCallback(submit, []);

  React.useEffect(() => {
    if (isShowing) {
      submit2(hnStory);
    }
  }, [isShowing, hnStory, submit2]);

  return (
    <span
      className="font-mono text-sm leading-6 italic"
      title={`Summary generated by OpenRouter ${object?.model} and may be inaccurate or incorrect.`}
    >
      {isLoading ? `${object?.summary || ""}.` : object?.summary}
    </span>
  );
};
